var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-scale-transition',{attrs:{"hide-on-leave":""}},[(_vm.show)?_c('v-avatar',{staticClass:"mx-1",staticStyle:{"opacity":".8"},attrs:{"color":_vm.color,"size":"8","title":_vm.$t("modified")}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }